export const RESUME_MANAGEMENT_RESUME_TBS_GROUP = 'tabs_简历管理';

export const RESUME_MANAGEMENT_EVALUATION_TBS_GROUP = 'tabs_诊断报告';

export const RESUME_EVALUATION_GROUP = 'evaluation_简历诊断';

export const RESUME_EVALUATION_PAID_LANDING_ID = 'landing_付费引导页';

export const RESUME_EVALUATION_FULL_REPORT_ID = 'report_完整报告页';
